export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'self-center text-center',
    },
    name: {
      name: 'ชื่อรายการ',
      width: '20rem',
    },
    width: {
      name: 'ความกว้าง (ซม.)',
      width: '8rem',
      class: 'self-center text-center',
    },
    length: {
      name: 'ความยาว (ซม.)',
      width: '8rem',
      class: 'self-center text-center',
    },
    height: {
      name: 'ความสูง (ซม.)',
      width: '8rem',
      class: 'self-center text-center',
    },
    count: {
      name: 'จำนวน',
      width: '8rem',
      class: 'self-center text-center',
    },
    weight: {
      name: 'น้ำหนัก (kg.)',
      width: '8rem',
      class: 'self-center text-center',
    },
    deliveryFee: {
      name: 'ค่าขนส่ง (บาท)',
      width: '8rem',
      class: 'self-center text-center',
    },
    unitsPerCount: {
      name: 'บรรจุ/ชิ้น',
      width: '8rem',
      class: 'self-center text-center',
    },
    unit: {
      name: 'หน่วย',
      width: '6rem',
      class: 'self-center text-center',
    },
    price: {
      name: 'ราคาสินค้า',
      width: '8rem',
      class: 'self-center text-center',
    },
    packageUnit: {
      name: 'หน่วยหีบห่อ',
      width: '8rem',
      class: 'self-center text-center',
    },
  },
};
